module.exports = __webpack_public_path__ + "img/banner5.d8f339e5.jpg";